/**
 * ReviewSection — summary, background-check toggle, consent checkbox.
 */
import React from 'react';
import { ShieldCheck } from '@phosphor-icons/react';
import { Field, Toggle } from './primitives';

export function ReviewSection({ form, set, isLight }) {
  const summary = [
    { k: 'Name', v: form.full_name },
    { k: 'Email', v: form.email },
    { k: 'Phone', v: form.phone },
    { k: 'Location', v: form.work_location || '—' },
    { k: 'Position', v: form.position || '—' },
    { k: 'Earliest start', v: form.earliest_start_date || '—' },
  ];
  return (
    <div className="space-y-4" data-testid="section-review">
      <div className="rounded-2xl p-4"
        style={{
          background: isLight ? 'rgba(241,245,249,0.7)' : 'rgba(10,10,14,0.6)',
          border: `1px solid ${isLight ? '#E2E8F0' : 'rgba(255,255,255,0.08)'}`,
        }}>
        <div className="text-[10px] font-black uppercase tracking-[0.22em] mb-3"
          style={{ color: '#10B981' }}>Quick summary</div>
        <div className="space-y-1.5">
          {summary.map(row => (
            <div key={row.k} className="flex items-center text-[12px]">
              <span className="font-black w-28 shrink-0" style={{ color: 'var(--cs-text-muted)' }}>{row.k}</span>
              <span className="font-bold" style={{ color: 'var(--cs-text)' }}>{row.v || '—'}</span>
            </div>
          ))}
        </div>
      </div>

      <Field label="Open to a background check" icon={<ShieldCheck size={11} weight="fill" />} testId="field-background">
        <Toggle value={form.can_pass_background_check} onChange={set('can_pass_background_check')} isLight={isLight}
          testId="toggle-background"
          options={[
            { value: true, label: 'Yes' },
            { value: false, label: 'No' },
          ]} />
      </Field>

      <label className="flex items-start gap-2.5 cursor-pointer rounded-xl p-3"
        style={{ background: isLight ? '#FFFFFF' : 'rgba(10,10,14,0.6)',
                 border: `1px solid ${isLight ? '#E2E8F0' : 'rgba(255,255,255,0.08)'}` }}>
        <input type="checkbox" checked={form.consent_contact} onChange={(e) => set('consent_contact')(e.target.checked)}
          className="mt-1 accent-[#10B981]"
          data-testid="checkbox-consent" />
        <div className="text-[11px] leading-relaxed" style={{ color: 'var(--cs-text)' }}>
          I consent to be contacted about this opportunity by phone, text, or email.
          {' '}<span style={{ color: 'var(--cs-text-muted)' }}>You can opt out any time.</span>
        </div>
      </label>
    </div>
  );
}
